var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoomInv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.052 10.944A1.23 1.23 0 0 0 5.28 9.722c0-.338-.137-.644-.36-.865a1.23 1.23 0 0 0-2.097.865 1.23 1.23 0 0 0 1.229 1.222m-2.568 0h.84a2.1 2.1 0 0 1-.392-1.223c0-.583.237-1.11.62-1.49a2.12 2.12 0 0 1 1.5-.618A2.12 2.12 0 0 1 6.1 9.184c.246-.127.527-.2.823-.2h9.609c.678 0 1.295.276 1.742.722A2.44 2.44 0 0 1 19 11.44v4.117c0 .245-.2.443-.445.443a.444.444 0 0 1-.446-.443v-1.662H.891v1.662c0 .245-.2.443-.446.443A.444.444 0 0 1 0 15.557V8.603a.445.445 0 0 1 .891 0v2.465a1.5 1.5 0 0 1 .592-.124zm3.052.886H1.484a.6.6 0 0 0-.418.172l-.002.001a.58.58 0 0 0-.172.409v.015c.002.16.068.303.172.408l.002.002a.6.6 0 0 0 .418.172h3.051a.6.6 0 0 0 .418-.172l.002-.002a.585.585 0 0 0 0-.832l-.002-.001a.6.6 0 0 0-.418-.172m9.12-6.39a.44.44 0 0 1 .153.605.444.444 0 0 1-.608.152L9.5 4 5.8 6.197a.445.445 0 0 1-.608-.152.44.44 0 0 1 .153-.605l3.922-2.329a.45.45 0 0 1 .462-.004zm5.126 0a.44.44 0 0 1 .153.605.445.445 0 0 1-.608.152L9.499.955.673 6.197a.446.446 0 0 1-.61-.152.44.44 0 0 1 .154-.605L9.266.066a.45.45 0 0 1 .46-.004zM6.018 13.008h12.091V11.44c0-.43-.178-.823-.464-1.108a1.58 1.58 0 0 0-1.113-.461H6.923a.91.91 0 0 0-.906.902z",
    fill: "#373E51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoomInv);
export default __webpack_public_path__ + "static/media/ic_room_inv.5b79ba3d89cd0c55bc394e74e7782bbc.svg";
export { ForwardRef as ReactComponent };